// extracted by mini-css-extract-plugin
export default {"searchArea":"SearchBar_searchArea__+jidt","Search":"SearchBar_Search__GQay+","button":"SearchBar_button__ljTbC","btn":"SearchBar_btn__DapXr"};